import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'
import '@livekit/components-styles'
import App from './App'
import { apolloClient } from './apollo/client'
import { AuthProvider } from './auth/AuthContext'
import { CartProvider } from './lib/cart'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        {/* CartProvider needs both Apollo (queries) and Auth (identity). */}
        <CartProvider>
          <BrowserRouter
            future={{
              // Opt-in to React Router v7 behaviour now so the upgrade
              // is a no-op when v7 ships and to silence the dev warnings.
              v7_startTransition: true,
              v7_relativeSplatPath: true
            }}
          >
            <App />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ApolloProvider>
  </React.StrictMode>
)
